import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnChanges, effect} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import dayjs from 'dayjs';
import { HelperService, IdentifierService } from 'merlin-core';
import { CountryCdEnum, ICMDeviceEnum as ICM,NGQDeviceEnum as NGQ, UserProfileObject, UserService } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { ActionError } from 'projects/clinician/src/app/my-account/services/my-account.model';
import { Observable, of } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { ClinicDetailsModel } from '../../../models/enroll-patient-device-data.model';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';

import { ViewleadsDialogComponent } from '../viewleads-dialog/viewleads-dialog.component';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { EnrollPatientDeviceDataService } from '../../../services/enroll-patient-device-data.service';
import { TransmissionDetailService } from '../../../services/transmission-detail.service';
import { AVEIR_VR_CODES, AVEIR_AR_CODES, AVEIR_ALL_CODES } from './device-codes.constants';
@Component({
    selector: 'app-device-transmit-information',
    templateUrl: './device-transmit-information.component.html',
    styleUrls: ['./device-transmit-information.component.scss'],
    standalone: false
})
export class DeviceTransmitInformationComponent implements OnInit, OnChanges {
    filteredOptions: Observable<any[]>;
    drFilteredOptions: Observable<any[]>; // filtered list for DR device name
    filteredDeviceList: Observable<any[]>; // search-filtered list for primary device mat-select
    deviceSearchControl = new FormControl('');
    drDeviceSearchControl = new FormControl('');
    deviceNameControl = new FormControl();
    implantPhySearchControl = new FormControl('');
    implantPhySearchControlDR = new FormControl('');
    public deviceForm: FormGroup;
    public aveirPairLabel: string;
    isRequiredImplantDateForUS: boolean;
    userProfileObject: UserProfileObject;
    OrdTrDate:any;
    devicesToBeDisabled = [
        // ICM.ICM3500,
        // ICM.ICM4500,
        // NGQ.Avant_VR_CDVRA700Q,
        // NGQ.Avant_DR_CDVRA700Q,
        // NGQ.Avant_HF_CDVRA700Q,
        // NGQ.Gallant_VR_CDVRA500Q,
        // NGQ.Gallant_DR_CDDRA500Q,
        // NGQ.Gallant_HF_CDHFA500Q,
        // NGQ.Entrant_VR_CDVRA300Q,
        // NGQ.Entrant_DR_CDDRA300Q,
        // NGQ.Entrant_HF_CDHFA300Q,
        // NGQ.Neutrino_NXTVR_CDVRA800Q,
        // NGQ.Neutrino_NXTDR_CDDRA800Q,
        // NGQ.Neutrino_NXTHF_CDHFA800Q,
        // NGQ.Neutrino_NXTVR_CDVRA600Q,
        // NGQ.Neutrino_NXTDR_CDDRA600Q,
        // NGQ.Neutrino_NXTHF_CDHFA600Q,
    ];
    trueInfo = [];
    showTrueAAIInfoFlag = false;
    deviceList = [];
    filterImplantPhyIdsOption :Observable<any[]>;
    filterImplantPhyIdsOptionDr :Observable<any[]>;
    searchTxt;
    errorMsgs = [];
    public transmitterVisibleOnEmpty: boolean = false;
    patientStatusCd?: number;
    transPatientImplantPhyIdData?:string;
    drtransPatientImplantPhyIdData?:string;
    drImplantPhyData = {};
    drImplantPhyId = null;
    implantPhyId?:number;
    // Flag to control DR Device checkbox visibility
    showDrDeviceCheckbox: boolean = false;
    // Set of Aveir device product codes used for pairing logic (VR + AR)
    private readonly aveirVrCodes: Set<string> = new Set(AVEIR_VR_CODES);
    private readonly aveirArCodes: Set<string> = new Set(AVEIR_AR_CODES);
    private readonly aveirAllCodes: Set<string> = new Set(AVEIR_ALL_CODES);
    // Holds resolved pair label (from API or local fallback)
    public isAveir: boolean = false;
    showRemoveButtons: boolean = false;
    primaryDeviceRemoved: boolean = false;
    drDeviceRemoved: boolean = false;
    originalDrDeviceData: any = null;
    private editModeOriginalDeviceCount: number = 0;

    @Input() dataMiningFlg = false;
    @Input() isBack;
    @Input() activatorClinicFlg;
    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() patientData: any;
    @Input() orderTransmitterMsg: string;
    @Input() public dropDownsList;
    @Input() public dateLabel;
    @Input() public clinicDetailsInfo: ClinicDetailsModel;
    @Output() public togglePhysicianOpt: EventEmitter<any> = new EventEmitter();
    @Input() public showPhysicianOpt = false;
    @Input() public implantIds;
    @Input() public isNGQCategory;
    @Input() public isICMCategory;
    @Input() public isLPCategory: boolean = false;
    @Input() public isUnityCategory;
    @Output() public transmitterSelect: EventEmitter<any> = new EventEmitter();
    @Output() public dataChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() userProfile: UserProfileObject;
    @Input() cliniciansList;
    @Input() public patientDeviceForm: FormGroup;

    public stringLabels = [
        "label.gb.device_data",
        "label.gb.view_leads",
        "label.gb.serial_number",
        "label.gb.dev_name",
        "label.gb.implant_date",
        "label.gb.doc_perform_implant",
        "label.gb.select_physician",
        "label.gb.doc_perform_implant",
        "label.gb.lead_chamber",
        "label.gb.DR_chk",
        "label.gb.serial_number",
        "label.gb.dev_name",
        "label.gb.implant_date",
        "label.gb.device_label",
        "label.gb.transmitter",
        "label.gb.order_transmit",
        "label.gb.pat_has_trans",
        "label.gb.record_data_collection_consent",
        "label.gb.search",
        "label.gb.selectDR",
        "label.gb.device_label",
        "label.gb.DR"
    ];

    public labels: Record<string, string>;

    constructor(
        public dialog: MatDialog,
        public identifierService: IdentifierService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private helperService: HelperService,
        private localizationService: LocalizationService,
        private toasterService: ToastrService,
        private userService: UserService,
        private transmissionDetailService: TransmissionDetailService,
        private enrollService: EnrollPatientDeviceDataService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        /* commenting this code as its not fetching patRes data*/
        // const dt=this.patRes?.patient?.transmitterOrderDate;
        // const tz = this.dateLabel?this.dateLabel?.toUpperCase():'DD/MM/YYYY';
        // this.OrdTrDate=this.localizationService.generateLocalizedStr(
        //     'label.gb.transmitter_order_date',
        //      { '0': dayjs(dt)?.format(tz) },'text'
        // )
    }

    ngOnChanges(change) {
        this.transmitterVisibleOnEmpty = (this.isICMCategory || this.isNGQCategory || this.isLPCategory) ? false : true;
        if (change?.dropDownsList?.currentValue) {
            if(!this.labels){
                this.translateStrings();
            }
            for (let leadChmbCode of change?.dropDownsList?.currentValue?.leadChmbCodes || []) {
                let key = "data.Code."+leadChmbCode.qualifier+".Code_Desc."+leadChmbCode.code
                this.labels[key] = this.localizationService.generateLocalizedStr(key);
            }
        }
        if (change?.patRes && change?.patRes?.currentValue && Object.keys(change.patRes.currentValue).length > 0 && change?.patRes?.currentValue !== change?.patRes?.previousValue) {
            let data = change?.patRes?.currentValue;
            this.patientStatusCd = data?.patient?.patientStatusCd;
            let primaryDevice = this.getPrimaryPatientDevice(this.patRes);
            let secondaryDevice = this.getSecondaryPatientDevice(this.patRes);

            if (primaryDevice) {
                this.implantPhyId = primaryDevice.implantPhyId;
            }

            if (this.implantPhyId) {
                let implantPhyIdName = this.patRes.dropdowns?.clinicians?.find(
                    (device) => device.acctId == this.implantPhyId
                );
                if (implantPhyIdName) {
                    this.deviceForm?.get('implantPhyIdName').setValue(implantPhyIdName);
                }
                this.togglePhysicianOpt.emit(implantPhyIdName?.value);
            }
            this.deviceForm?.get('isImplantPhysicianEditable')?.setValue(primaryDevice?.isImplantPhysicianEditable);
            this.drImplantPhyId = secondaryDevice?.implantPhyId;
            if (this.drImplantPhyId && this.patRes?.dropdowns?.clinicians) {
                const drImplantPhy = this.patRes?.dropdowns?.clinicians.find(c => String(c.acctId) === String(this.drImplantPhyId));
                if (drImplantPhy) {
                    this.deviceForm?.get('drImplantPhyIdName')?.patchValue(drImplantPhy);
                }
            }
            this.deviceForm?.get('isImplantPhysicianEditableDR')?.setValue(secondaryDevice?.isImplantPhysicianEditable ?? true);
            if (this.functionMode == 'enroll' && this.patientStatusCd==48) {
            // for enroll mode if patient is transferred, then assigning implanting physician data
                // Get transferred patient physician name correctly
                if(!primaryDevice?.isImplantPhysicianEditable) {
                    this.transPatientImplantPhyIdData = ['',null,'--',undefined].includes(this.transPatientImplantPhyIdData) ? this.enrollService.getTransferredImplantingPhys(primaryDevice) : this.transPatientImplantPhyIdData;
                    if (this.deviceForm?.get('transPatientImplantPhyIdData')) {
                        this.deviceForm?.get('transPatientImplantPhyIdData')?.patchValue(this.transPatientImplantPhyIdData);
                    }
                }
                if(!(secondaryDevice?.isImplantPhysicianEditable ?? true)) {
                    this.drtransPatientImplantPhyIdData = ['',null,'--',undefined].includes(this.drtransPatientImplantPhyIdData) ? this.enrollService.getTransferredImplantingPhys(secondaryDevice) : this.drtransPatientImplantPhyIdData;
                    if (this.deviceForm?.get('drTransPatientImplantPhyIdData')) {
                        this.deviceForm?.get('drTransPatientImplantPhyIdData')?.patchValue(this.drtransPatientImplantPhyIdData);
                    }
                }
            }

        }
        // this.deviceForm?.get('implantPhyId')?.setValue(String(this.patRes?.patientDevice?.implantPhyId? this.patRes?.patientDevice?.implantPhyId : ''));
        let productId=this.deviceForm?.get('productId')?.value;
        this.deviceForm?.get('productId').valueChanges.subscribe((change) => {
            this.togglePhysicianOpt.emit(change);
            this.updateAveirFlag(change);
            this.filterDrDeviceList();
        });
        this.deviceList = !this.dropDownsList.devices
            ? change?.patRes?.currentValue?.dropdowns?.devices
            : this.dropDownsList.devices;
        if (this.deviceList == undefined) {
            return;
        }

        this.deviceList.sort((a, b) => {
            let fa = a.label.toLowerCase(),
                fb = b.label.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        })

        this.implantIds.sort((a, b) => {
            let aName = a.lastName.toLowerCase(),
                bName = b.lastName.toLowerCase();

            if (aName < bName) {
                return -1;
            }
            if (aName > bName) {
                return 1;
            }
            return 0;
        })

        this.deviceList = this.deviceList.map(deviceDD=>{
            let found = this.devicesToBeDisabled.some(
                (device) => device.toString() === deviceDD.value.toString()
            );
            let finalObj = {
                ...deviceDD,
                disabled: found
            }

            return finalObj;
        });
        if (this.deviceForm?.get('productId').value != '') {
            let productName = this.deviceList?.find(
                (device) => device.value == productId
            );
            if (productName) {
                this.deviceForm?.get('productId').setValue(productName.value, { emitEvent: false });
            }
            this.deviceForm?.get('productName').setValue(productName);
            this.togglePhysicianOpt.emit(productName?.value);
            this.updateAveirFlag(productId);
            const matchedDevice = this.dropDownsList?.devices?.find(d => String(d.value) === String(productId));
            if (matchedDevice?.deviceModelNum) {
                this.deviceForm?.get('modelNum')?.setValue(matchedDevice.deviceModelNum, { emitEvent: false });
            }
        }
        
        // Set drProductName from deviceList if drProductId has a value (for back navigation)
        const drProductId = this.deviceForm?.get('drProductId')?.value;
        if (drProductId && drProductId !== '') {
            let drProductName = this.deviceList?.find(
                (device) => device.value == drProductId
            );
            if (drProductName) {
                this.deviceForm?.get('drProductId').setValue(drProductName.value, { emitEvent: false });
                this.deviceForm?.get('drProductName').setValue(drProductName);
            }
            const matchedDrDevice = this.dropDownsList?.devices?.find(d => String(d.value) === String(drProductId));
            if (matchedDrDevice?.deviceModelNum) {
                this.deviceForm?.get('drModelNum')?.setValue(matchedDrDevice.deviceModelNum, { emitEvent: false });
            }
            // Ensure drDevice checkbox is checked if we have a DR product
            if (this.deviceForm?.get('drDevice')?.value !== true && !this.showRemoveButtons) {
                this.deviceForm?.get('drDevice')?.setValue(true, { emitEvent: false });
            }
            // Ensure drFilteredOptions is set up with current values
            this.updateAveirFlag(this.deviceForm?.get('productId')?.value);
            this.filterDrDeviceList();
        }
        
        // When entering edit mode from view, auto-populate DR device fields if second device exists
        if (change?.displayMode?.currentValue === 'edit') {
            this.editModeOriginalDeviceCount = this.patRes?.patientDevices?.length ?? 0;
            this.prepopulateDrDeviceFromPatRes();
        }
        if (change?.patRes && this.displayMode === 'edit' && this.editModeOriginalDeviceCount === 0) {
            this.editModeOriginalDeviceCount = this.patRes?.patientDevices?.length ?? 0;
        }
        

        // if (['', null, undefined].includes(this.deviceForm.get('implantPhyId').value)){
            this.filterImplantPhyIdsOption = this.implantPhySearchControl
                .valueChanges.pipe(
                    startWith(''),
                    map((value) => this.filterPhyId(value))
                );
            this.filterImplantPhyIdsOptionDr = this.implantPhySearchControlDR
                .valueChanges.pipe(
                    startWith(''),
                    map((value) => this.filterPhyId(value))
                );
            //   }


        // Always set up filteredOptions for primary device to show all devices
        this.filteredOptions = this.deviceForm
            ?.get('productName')
            .valueChanges.pipe(
                startWith(''),
                map((value) => this._filter(value))
            );
        this.setupFilteredDeviceList();
            
        // ensure flag updated for pre-populated value
        if (this.deviceForm?.get('productId').value) {
            this.updateAveirFlag(this.deviceForm?.get('productId').value);
        }
        this.togglePhysicianOpt.emit(change?.patRes);
        this.trueInfo = change?.clinicDetailsInfo?.currentValue
            ? change?.clinicDetailsInfo?.currentValue?.trueAAIProdIds.split(',')
            : [];
        this.getArVrPairLabel()
    }

    ngOnInit() {
        this.translateStrings();
        this.aveirPairLabel = this.labels['label.gb.selectDR'];
        this.transmitterVisibleOnEmpty = (this.isICMCategory || this.isNGQCategory || this.isLPCategory) ? false : true;
        this.deviceForm = this.patientDeviceForm?.get('deviceData') as FormGroup;
        this.deviceForm?.addControl('productName', new FormControl(''));
        this.deviceForm?.addControl('implantPhyIdName', new FormControl(''));
        this.deviceForm?.addControl('patientDeviceId', new FormControl(''));
        this.deviceForm?.addControl('transPatientImplantPhyIdData', new FormControl(''));
        this.deviceForm?.addControl('isImplantPhysicianEditable', new FormControl(true));
        // Added drDevice checkbox control defaulting to false
        // Add drDevice checkbox control and associated form controls
        if(!this.deviceForm?.get('drDevice')) {
            this.deviceForm?.addControl('drDevice', new FormControl(false));
            // Re-add DR device related form controls as requested
            this.deviceForm?.addControl('drSerialNum', new FormControl(''));
            this.deviceForm?.addControl('drProductId', new FormControl(''));
            this.deviceForm?.addControl('drProductName', new FormControl(''));
            this.deviceForm?.addControl('drModelNum', new FormControl(''));
            this.deviceForm?.addControl('drImplantDate', new FormControl(''));
            this.deviceForm?.addControl('drImplantPhyId', new FormControl(''));
            this.deviceForm?.addControl('drImplantPhyIdName', new FormControl(''));
            this.deviceForm?.addControl('drTransPatientImplantPhyIdData', new FormControl(''));
            this.deviceForm?.addControl('drPrevSerialNum', new FormControl(''));
            this.deviceForm?.addControl('drPrevProductId', new FormControl(''));
            this.deviceForm?.addControl('drPrevPatientDeviceId', new FormControl(''));
            this.deviceForm?.addControl('drPatientDeviceId', new FormControl(''));
            this.deviceForm?.addControl('drEditReason', new FormControl(''));
            this.deviceForm?.addControl('drDevChanged', new FormControl(''));
            this.deviceForm?.addControl('isImplantPhysicianEditableDR', new FormControl(true));
        }
        if (!this.deviceForm?.get('deviceRemovalState')) {
            this.deviceForm?.addControl('deviceRemovalState', new FormControl('none'));
        }
        this.trueInfo = this.clinicDetailsInfo
            ? this.clinicDetailsInfo.trueAAIProdIds.split(',')
            : [];
            this.deviceForm?.get('productId').valueChanges.subscribe((change) => {
                this.togglePhysicianOpt.emit(change);
                this.updateAveirFlag(change);
                this.filterDrDeviceList();
            });
        this.deviceForm?.get('transmitter').valueChanges.subscribe((change) => {
            this.transmitterSelect.emit(change);
        });

        this.deviceForm?.get('drDevice').valueChanges.subscribe((checked) => {
            const drFields = [
                'drSerialNum','drProductId','drProductName','drImplantDate','drImplantPhyId','drImplantPhyIdName','drPrevSerialNum','drPrevProductId','drPrevPatientDeviceId','drPatientDeviceId','drEditReason','drDevChanged'
            ];
            
            if (this.displayMode === 'edit' && !checked) {
                const hasDrData = this.deviceForm.get('drSerialNum')?.value || 
                                  this.deviceForm.get('drProductId')?.value;
                const originallyHadTwoDevices = this.editModeOriginalDeviceCount >= 2;
                if (hasDrData && originallyHadTwoDevices) {
                    if (!this.originalDrDeviceData) {
                        this.originalDrDeviceData = {
                            drSerialNum: this.deviceForm.get('drSerialNum')?.value,
                            drProductId: this.deviceForm.get('drProductId')?.value,
                            drProductName: this.deviceForm.get('drProductName')?.value,
                            drImplantDate: this.deviceForm.get('drImplantDate')?.value,
                            drImplantPhyId: this.deviceForm.get('drImplantPhyId')?.value,
                            drImplantPhyIdName: this.deviceForm.get('drImplantPhyIdName')?.value
                        };
                    }
                    this.showRemoveButtons = true;
                    this.primaryDeviceRemoved = false;
                    this.drDeviceRemoved = false;
                    this.getArVrPairLabel();
                    return; 
                }
            }
            
            if (checked && this.showRemoveButtons) {
                this.showRemoveButtons = false;
                this.primaryDeviceRemoved = false;
                this.drDeviceRemoved = false;
                this.deviceForm.get('deviceRemovalState')?.setValue('none', { emitEvent: false });
                
                const primaryFields = ['serialNum', 'productId', 'productName', 'implantDate', 'implantPhyId', 'implantPhyIdName'];
                primaryFields.forEach(ctrl => {
                    const c = this.deviceForm.get(ctrl);
                    if (c && c.disabled) {
                        c.enable({emitEvent: false});
                    }
                });
            }
            
            drFields.forEach(ctrl => {
                const c = this.deviceForm?.get(ctrl);
                if(!c) return;
                if(checked) { 
                    c.enable({emitEvent:false});
                    if(this.displayMode === 'enroll'){
                        c?.setValue(this.drImplantPhyData ? this.drImplantPhyData[ctrl] : '', {emitEvent:false}); // Restore value if we have it stored
                    }
                    if(ctrl === 'drSerialNum' || ctrl === 'drProductId') {
                        c.setValidators([Validators.required]);
                        c.updateValueAndValidity({emitEvent:false});
                    }
                } else { 
                    if (!this.showRemoveButtons) {
                        c.disable({emitEvent:false}); 
                        this.drImplantPhyData[ctrl] = c.value; // Store current value before clearing
                        c.reset('', {emitEvent:false});
                        c.clearValidators();
                        c.updateValueAndValidity({emitEvent:false});
                    }
                }
            });
            this.getArVrPairLabel();
        });

        this.deviceList = this.dropDownsList.devices;
        this.setupFilteredDeviceList();
        this.bindFieldsData();
        this.userService.getUserProfile(false).subscribe(
            (userData: UserProfileObject) => {
                this.userProfileObject=userData;
                this.isRequiredImplantDateForUS = this.userProfileObject?.clinicCountryCd === CountryCdEnum.USA;
            })
        let productId=this.deviceForm?.get('productId')?.value;
        if (this.deviceForm.get('productId').value != '') {
            if(!this.deviceList || this.deviceList.length === 0) {
                    let productName = this.deviceList?.find(
                    (device) => device.value == productId
                );
                this.deviceForm.get('productName').setValue(productName);
                this.togglePhysicianOpt.emit(productName?.value);
            }
            this.updateAveirFlag(productId);
            this.filterDrDeviceList();
        }
        let acctId = this.deviceForm.get('implantPhyId').value;
        if (this.deviceForm.get('implantPhyId').value != '') {
            let implantPhyIdName = this.patRes.dropdowns?.clinicians.find(
                (device) => device.acctId == acctId
            );
            this.deviceForm.get('implantPhyIdName').setValue(implantPhyIdName);
            this.togglePhysicianOpt.emit(implantPhyIdName?.value);
        }
        
        // Set drProductName from deviceList if drProductId has a value (for back navigation in ngOnInit)
        const drProductId = this.deviceForm.get('drProductId')?.value;
        if (drProductId && drProductId !== '') {
            let drProductName = this.deviceList.find(
                (device) => device.value == drProductId
            );
            if (drProductName) {
                this.deviceForm.get('drProductName').setValue(drProductName);
            }
            // Ensure drDevice checkbox is checked if we have a DR product
            if (this.deviceForm.get('drDevice')?.value !== true && !this.showRemoveButtons) {
                this.deviceForm.get('drDevice')?.setValue(true, { emitEvent: false });
            }
            // Also set drImplantPhyIdName if drImplantPhyId has a value
            const drAcctId = this.deviceForm.get('drImplantPhyId')?.value;
            if (drAcctId && drAcctId !== '') {
                let drImplantPhyIdName = this.patRes.dropdowns?.clinicians.find(
                    (clinician) => clinician.acctId == drAcctId
                );
                if (drImplantPhyIdName) {
                    this.deviceForm.get('drImplantPhyIdName').setValue(drImplantPhyIdName);
                }
            }
            // Ensure drFilteredOptions is set up with current values
            this.filterDrDeviceList();
        }
        
         this.deviceForm.get('patientDeviceId').setValue(this.patRes.patientDeviceId);
        
        
        // Attempt DR device prepopulation in init for edit state.
        if (this.displayMode === 'edit') {
            if (this.editModeOriginalDeviceCount === 0) {
                this.editModeOriginalDeviceCount = this.patRes?.patientDevices?.length ?? 0;
            }
            this.prepopulateDrDeviceFromPatRes();
        }

        const sub = this.deviceForm.get('productName').valueChanges.subscribe(val => {
            if (val) {
                this.filterDevices(val);
                sub.unsubscribe();
            }
        })
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }


    // Updates the flag determining visibility of DR Device checkbox (any Aveir code)
    private updateAveirFlag(prodId: any) {
        const code = String(prodId || '').trim();
        const isAveirCode = this.aveirAllCodes.has(code);

        if (code === '' && this.displayMode === 'edit') {
            return;
        }

        this.showDrDeviceCheckbox = isAveirCode;
        this.isAveir = isAveirCode;

        if (!isAveirCode && this.deviceForm?.get('drDevice')) {
            this.clearDrDeviceFields();
        }
    }

    // Clear all DR device fields, validations, and uncheck the checkbox
    private clearDrDeviceFields() {
        if (!this.deviceForm) return;
        
        // Uncheck the DR device checkbox
        this.deviceForm.get('drDevice')?.setValue(false, { emitEvent: false });
        
        // List of all DR device form controls
        const drFields = [
            'drSerialNum', 'drProductId', 'drProductName', 'drImplantDate', 
            'drImplantPhyId', 'drImplantPhyIdName', 'drPrevSerialNum', 
            'drPrevProductId', 'drPrevPatientDeviceId', 'drPatientDeviceId', 
            'drEditReason', 'drDevChanged'
        ];
        
        // Clear values, remove validations, and disable fields
        drFields.forEach(fieldName => {
            const control = this.deviceForm.get(fieldName);
            if (control) {
                control.setValue('', { emitEvent: false });
                control.clearValidators();
                control.updateValueAndValidity({ emitEvent: false });
                control.setErrors(null);
            }
        });
        
        // Clear the filtered options observable
        this.drFilteredOptions = null;
    }

    // Filter DR device autocomplete options to opposite Aveir type
    private filterDrDeviceList() {
        if(!this.showDrDeviceCheckbox) { this.drFilteredOptions = null; return; }
        const primaryCode = String(this.deviceForm.get('productId')?.value || '').trim();
        if(!primaryCode) {
            // In edit mode, preserve the existing DR dropdown rather than clearing it
            // so that clearing the primary name doesn't hide the DR device section.
            if (this.displayMode !== 'edit') { this.drFilteredOptions = null; }
            return;
        }
        const primaryIsVr = this.aveirVrCodes.has(primaryCode);
        const primaryIsAr = this.aveirArCodes.has(primaryCode);
        // Only filter within Aveir set; others return null
        if(!(primaryIsVr || primaryIsAr)) { this.drFilteredOptions = null; return; }
        const targetSet = primaryIsVr ? this.aveirArCodes : this.aveirVrCodes; // opposite group
        const filtered = this.deviceList?.filter(d => targetSet.has(String(d.value)));
        this.drFilteredOptions = this.drDeviceSearchControl.valueChanges.pipe(
            startWith(''),
            map((search: string) => {
                if (!search) return filtered?.slice() || [];
                const term = search.toLowerCase();
                return filtered?.filter(d => d.label?.toLowerCase().includes(term)) || [];
            })
        );
    }

    ngAfterViewInit() {
        this.userProfile =  this.userProfileObject
    }

    private setupFilteredDeviceList() {
        this.filteredDeviceList = this.deviceSearchControl.valueChanges.pipe(
            startWith(''),
            map((search: string) => {
                if (!search) return this.deviceList?.slice() || [];
                const term = search.toLowerCase();
                return this.deviceList?.filter(d => d.label?.toLowerCase().includes(term)) || [];
            })
        );
    }

    private _filter(value: string | any): string[] {
        const filterValue =
            typeof value === 'object'
                ? value?.label?.toLowerCase()
                : (value || '')?.toLowerCase();

        return this.deviceList.filter((option) =>
            option.label?.toLowerCase().includes(filterValue)
        );
    }

    private filterPhyId(value: string | any): string[] {
        if (!value || value === '') {
            return this.implantIds || [];
        }
        
        const filterValue =
            typeof value === 'object'
                ? this.getImpData(value)?.toLowerCase()
                : (value || '')?.toLowerCase();
        
        if (!filterValue || filterValue.trim() === '') {
            return this.implantIds || [];
        }
        
        return this.implantIds?.filter((option) =>
           this.getImpData(option)?.toLowerCase()?.includes(filterValue)
        ) || [];
    }

    translatePlaceHolder(): string{
        let key = this.dateLabel?.toUpperCase() == 'DD-MM-YYYY'
                    ? 'label.gb.ddmmyyyy' :
                    this.dateLabel?.toUpperCase() == 'MM-DD-YYYY'
                    ? 'label.gb.mmddyyyy' : 'label.gb.yyyymmdd';
                    return this.localizationService.generateLocalizedStr(key);
    }

    // displayFn(deviceId): string {
    //     // if (deviceId)
    //     //     return this.deviceList
    //     //         ? this.deviceList.find((option) => option.value === deviceId)
    //     //               ?.label
    //     //         : deviceId;

    // }

    displayFn(device?: any): string | undefined {
        return device ? device.label : undefined;
    }

    /**
     * Helper to safely get primary patient device from API response.
     * API returns patientDevices as an array - returns first device or null.
     */
    private getPrimaryPatientDevice(data: any): any {
        if (!data) return null;
        if (data.patientDevices && Array.isArray(data.patientDevices) && data.patientDevices.length > 0) {
            return data.patientDevices[0];
        }
        return null;
    }
    /**
     * Helper to get secondary (DR) patient device if present.
     */
    private getSecondaryPatientDevice(data: any): any {
        if (!data) return null;
        if (data.patientDevices && Array.isArray(data.patientDevices) && data.patientDevices.length > 1) {
            return data.patientDevices[1];
        }
        return null;
    }

    /**
     * Prepopulate DR device form fields from patient response when entering edit mode.
     * Ensures AR device is always primary and VR device is always secondary.
     */
    private prepopulateDrDeviceFromPatRes(): void {
        if (!this.patRes || !this.deviceForm) return;
        
        let primary = this.getPrimaryPatientDevice(this.patRes);
        let secondary = this.getSecondaryPatientDevice(this.patRes);
        
        if (!secondary) return;
        
        // Check if devices need to be swapped (AR should always be primary)
        const primaryCode = String(primary?.productId || '').trim();
        const secondaryCode = String(secondary?.productId || '').trim();
        const primaryIsVr = this.aveirVrCodes.has(primaryCode);
        const secondaryIsAr = this.aveirArCodes.has(secondaryCode);
        
        // Swap if primary is VR and secondary is AR
        if (primaryIsVr && secondaryIsAr) {
            const temp = primary;
            primary = secondary;
            secondary = temp;
            
            // Update the primary device fields with AR device
            this.deviceForm.get('serialNum')?.patchValue(primary.serialNum || '');
            this.deviceForm.get('implantDate')?.patchValue(primary.implantDate || '');
            this.deviceForm.get('productId')?.patchValue(String(primary.productId || ''));
            this.deviceForm.get('implantPhyId')?.patchValue(primary.implantPhyId ? primary.implantPhyId : '');
            
            if (primary.productId && this.deviceList?.length) {
                const primaryProdName = this.deviceList.find(d => String(d.value) === String(primary.productId));
                if (primaryProdName) {
                    this.deviceForm.get('productName')?.patchValue(primaryProdName);
                }
            }
            
            if (primary.implantPhyId && this.patRes?.dropdowns?.clinicians) {
                const primaryImplantPhy = this.patRes.dropdowns.clinicians.find(c => String(c.acctId) === String(primary.implantPhyId));
                if (primaryImplantPhy) {
                    this.deviceForm.get('implantPhyIdName')?.patchValue(primaryImplantPhy);
                }
            }
            this.deviceForm.get('isImplantPhysicianEditable')?.patchValue(primary?.isImplantPhysicianEditable);
        }
        
        // Ensure checkbox visible even if primary not Aveir but secondary is
        this.updateAveirFlag(this.deviceForm.get('productId')?.value);
        if (!this.showDrDeviceCheckbox) {
            const secCode = String(secondary.productId || '').trim();
            if (this.aveirAllCodes.has(secCode)) {
                this.showDrDeviceCheckbox = true;
            }
        }
        if (!this.showDrDeviceCheckbox) return;
        this.deviceForm.get('drDevice')?.setValue(true, { emitEvent: false });
        this.deviceForm.get('drSerialNum')?.patchValue(secondary.serialNum || '');
        this.deviceForm.get('drImplantDate')?.patchValue(secondary.implantDate || '');
        this.deviceForm.get('drProductId')?.patchValue(String(secondary.productId || ''));
        this.deviceForm.get('drPrevSerialNum')?.patchValue(secondary.prevSerialNum || '');
        this.deviceForm.get('drPrevProductId')?.patchValue(secondary.prevProductId || '');
        this.deviceForm.get('drPrevPatientDeviceId')?.patchValue(secondary.prevPatientDeviceId || '');
        this.deviceForm.get('drPatientDeviceId')?.patchValue(secondary.patientDeviceId || '');
        this.deviceForm.get('drEditReason')?.patchValue(secondary.editReason || '');
        this.deviceForm.get('drDevChanged')?.patchValue(secondary.devChanged || '');
        if (secondary.productId && this.deviceList?.length) {
            const drProdName = this.deviceList.find(d => String(d.value) === String(secondary.productId));
            if (drProdName) {
                this.deviceForm.get('drProductName')?.patchValue(drProdName);
            }
        }
        this.deviceForm.get('drImplantPhyId')?.patchValue(secondary.implantPhyId ? secondary.implantPhyId : '');
        if (secondary.implantPhyId && this.patRes?.dropdowns?.clinicians) {
            const drImplantPhy = this.patRes.dropdowns.clinicians.find(c => String(c.acctId) === String(secondary.implantPhyId));
            if (drImplantPhy) {
                this.deviceForm.get('drImplantPhyIdName')?.patchValue(drImplantPhy);
            }
        }
        this.drImplantPhyId = secondary.implantPhyId;
        this.deviceForm.get('isImplantPhysicianEditableDR')?.patchValue(secondary?.isImplantPhysicianEditable ?? true);
        if (!(primary?.isImplantPhysicianEditable ?? true)) {
            this.transPatientImplantPhyIdData = this.enrollService.getTransferredImplantingPhys(primary);
            if (this.deviceForm?.get('transPatientImplantPhyIdData')) {
                this.deviceForm.get('transPatientImplantPhyIdData')?.patchValue(this.transPatientImplantPhyIdData);
            }
        }
        if (!(secondary?.isImplantPhysicianEditable ?? true)) {
            this.drtransPatientImplantPhyIdData = this.enrollService.getTransferredImplantingPhys(secondary);
            if (this.deviceForm?.get('drTransPatientImplantPhyIdData')) {
                this.deviceForm.get('drTransPatientImplantPhyIdData')?.patchValue(this.drtransPatientImplantPhyIdData);
            }
        }
        this.implantPhyId = primary.implantPhyId;
        this.drImplantPhyId = secondary.implantPhyId;
        this.filterDrDeviceList();
        this.getArVrPairLabel();
    }

    bindFieldsData() {
        this.requestService.getPatientProfile().pipe(take(1)).subscribe(
            (data) => {
                if (!data) return; // Ensure data exists
                if (data?.patient?.patientId &&
                    data.patient.patientId !== this.patRes?.patient?.patientId) {
                    this.patientStatusCd = this.patRes?.patient?.patientStatusCd ?? null;
                    this.implantPhyId = null;
                    return;
                }

                if (data.patient) {
                    const dt = data.patient.transmitterOrderDate;
                    const tz = this.dateLabel?.toUpperCase() || 'DD/MM/YYYY';
                    this.OrdTrDate = this.localizationService.generateLocalizedStr(
                        'label.gb.transmitter_order_date',
                        { '0': dt ? dayjs(dt).format(tz) : '--' }, // Ensure valid date format
                        'text'
                    );
                    this.patientStatusCd = data.patient.patientStatusCd; // Store patient status
                }
                // Use helper to get primary device from either old or new structure
                // Check if devices need to be swapped (AR should always be primary)
                let patientDevice = this.getPrimaryPatientDevice(data);
                const secondaryDevice = this.getSecondaryPatientDevice(data);
                
                // If both devices exist and need swapping (primary is VR, secondary is AR), swap them
                if (patientDevice && secondaryDevice) {
                    const primaryCode = String(patientDevice.productId || '').trim();
                    const secondaryCode = String(secondaryDevice.productId || '').trim();
                    const primaryIsVr = this.aveirVrCodes.has(primaryCode);
                    const secondaryIsAr = this.aveirArCodes.has(secondaryCode);
                    
                    if (primaryIsVr && secondaryIsAr) {
                        // Swap: use secondary (AR) as primary
                        patientDevice = secondaryDevice;
                    }
                }

                if (patientDevice) {
                    this.implantPhyId = patientDevice.implantPhyId;
                    // Prevent errors when accessing trueAAIProdIds
                    const trueAAIProdIds = data.clinicDetails?.trueAAIProdIds?.split(',') || [];
                    this.showTrueAAIInfoFlag = trueAAIProdIds.includes(String(patientDevice.productId));

                    this.deviceForm.get('serialNum')?.patchValue(patientDevice.serialNum);
                    this.deviceForm.get('implantDate')?.patchValue(patientDevice.implantDate);
                    this.deviceForm.get('productId')?.patchValue(String(patientDevice.productId));
                    this.togglePhysicianOpt.emit(String(patientDevice.productId));

                    // Set productName from deviceList
                    if (patientDevice.productId && this.deviceList?.length) {
                        const productNameObj = this.deviceList.find(d => String(d.value) === String(patientDevice.productId));
                        if (productNameObj) {
                            this.deviceForm.get('productName')?.patchValue(productNameObj);
                        }
                    }

                    this.deviceForm.get('implantPhyId')?.patchValue(
                        patientDevice.implantPhyId ? patientDevice.implantPhyId : ''
                    );

                    // Set implantPhyIdName from clinicians list
                    if (patientDevice.implantPhyId && data?.dropdowns?.clinicians) {
                        const implantPhyObj = data.dropdowns.clinicians.find(c => String(c.acctId) === String(patientDevice.implantPhyId));
                        if (implantPhyObj) {
                            this.deviceForm.get('implantPhyIdName')?.patchValue(implantPhyObj);
                        }
                    }
                    this.deviceForm.get('isImplantPhysicianEditable')?.patchValue(patientDevice?.isImplantPhysicianEditable);

                    // Get transferred patient physician name correctly
                    if(!patientDevice?.isImplantPhysicianEditable) {
                        this.transPatientImplantPhyIdData = this.enrollService.getTransferredImplantingPhys(patientDevice);

                        if (this.deviceForm.get('transPatientImplantPhyIdData')) {
                            this.deviceForm.get('transPatientImplantPhyIdData')?.patchValue(this.transPatientImplantPhyIdData);
                        }
                    }
                    
                    // Update Aveir flag and filter DR device list
                    this.updateAveirFlag(String(patientDevice.productId));
                    this.filterDrDeviceList();

                }
            },

            (err) => {

                if (err && err.actionErrors) {
                    this.showToaster(err.actionErrors);
                } else {
                    this.helperService.showErrorToastr(err);
                }
            }
        );
    }


    filterDevices(val) {
        this.filteredOptions = this.deviceForm
            .get('productName')
            .valueChanges.pipe(
                startWith(''),
                map((value) => this._filter(val))
            );
    }

    validateImplatId(event) {
        this.toasterService.clear();
    }

    validateDevice(event: Event) {
        this.toasterService.clear();
        let manualDeviceInput = (event.target as HTMLInputElement).value;
        let isValid = this.dropDownsList.devices?.some(option => (option.label).toUpperCase() === manualDeviceInput.toUpperCase());
        let product = this.dropDownsList.devices?.filter(option => (option.label).toUpperCase() === manualDeviceInput.toUpperCase());
        if (!isValid) {
            this.deviceForm.get('productName').setErrors({ 'invalidOption': true });
            this.deviceList = this.dropDownsList.devices;
            this.filterDevices(manualDeviceInput);
        } else {

            this.deviceForm.get('productName').setErrors(null);
            //updating device on manual selection
            let rawFormData = this.patientDeviceForm.getRawValue();
            this.transmissionDetailService.updateDevice(
                {
                    isDeviceChange: true,
                    devName: manualDeviceInput,
                    patFirstName: rawFormData?.patientDetails?.firstName,
                    patLastName: rawFormData?.patientDetails?.lastName,
                    patientNum: rawFormData?.patientDetails?.patientNum
                });
            let manualProductId = product[0].value;
            this.togglePhysicianOpt.emit(manualProductId);
            const currentPhysicianId = this.deviceForm.get('implantPhyId').value;
            if (currentPhysicianId && currentPhysicianId !== '') {
                // Clear any validation errors on physician field if valid physician is selected
                this.deviceForm.get('implantPhyIdName').setErrors(null);
                this.deviceForm.get('implantPhyIdName').markAsTouched();
            }
           this.deviceList = this.deviceList.filter((option) => option.label?.toLowerCase().includes(manualDeviceInput.toLowerCase()));
            this.filterDevices(manualDeviceInput);
            this.deviceForm.get('productId').setValue(manualProductId);
            this.deviceForm.get('modelNum').setValue(product[0]?.deviceModelNum);
            this.deviceForm.get('productName').setValue(product[0]);
            this.updateAveirFlag(manualProductId);
            this.filterDrDeviceList();
            let imp_date = this. helperService.parseGMTDateTime(
                new Date(),
                false,
                false,
                this.userProfileObject?.clinicUserTZ,
                this.userProfileObject?.dateFormat,
                this.userProfileObject?.timeFormat,
                this.userProfileObject?.locale
                );
            if(this.clinicDetailsInfo?.icmProdIds?.split(',').includes(manualProductId?.toString())){
                this.enrollService.addressRequired.next(true);
                this.deviceForm
                    .get('implantDate')
                    .patchValue(imp_date);
            } else {
                this.enrollService.addressRequired.next(false);
            }
            if (this.clinicDetailsInfo?.avrProdIds?.split(',').includes(manualProductId?.toString())) {
                this.transmitterVisibleOnEmpty = false;
            } else if (this.clinicDetailsInfo?.icmProdIds?.split(',').includes(manualProductId?.toString())) {
                this.transmitterVisibleOnEmpty = false;
            } else if (this.clinicDetailsInfo?.ngqProdIds?.split(',').includes(manualProductId?.toString())) {
                this.transmitterVisibleOnEmpty = false;
            } else {
                this.transmitterVisibleOnEmpty = true;
            }
            this.getTrueAAIProd(manualProductId);
        }
    }

    deviceNameBlur(event: Event) {
        this.toasterService.clear();
        const manualDeviceInput = (event.target as HTMLInputElement).value?.trim();
    
        if (!manualDeviceInput) {
            this.deviceForm.get('productName').setErrors({ 'required': true });
            this.deviceForm.get('productId').setValue('');
            this.deviceForm.get('modelNum').setValue('');
            if (this.displayMode !== 'edit') {
                this.clearDrDeviceFields();
                this.showDrDeviceCheckbox = false;
            }
            return;
        }

        const matchedDevice = this.dropDownsList.devices?.find(option => 
            option.label?.toUpperCase() === manualDeviceInput.toUpperCase()
        );

        if (!matchedDevice) {
            this.deviceForm.get('productName').setErrors({ 'invalidOption': true });
        } else {
            this.deviceForm.get('productName').setErrors(null);
            const manualProductId = matchedDevice.value;
            this.deviceForm.get('productId').setValue(manualProductId);
            this.deviceForm.get('modelNum').setValue(matchedDevice.deviceModelNum);
            this.deviceForm.get('productName').setValue(matchedDevice);
            
            let rawFormData = this.patientDeviceForm.getRawValue();
            this.transmissionDetailService.updateDevice({
                isDeviceChange: true,
                devName: matchedDevice.label,
                patFirstName: rawFormData?.patientDetails?.firstName,
                patLastName: rawFormData?.patientDetails?.lastName,
                patientNum: rawFormData?.patientDetails?.patientNum
            });
            
            this.togglePhysicianOpt.emit(manualProductId);
            
            const currentPhysicianId = this.deviceForm.get('implantPhyId').value;
            if (currentPhysicianId && currentPhysicianId !== '') {
                this.deviceForm.get('implantPhyIdName').setErrors(null);
                this.deviceForm.get('implantPhyIdName').markAsTouched();
            }
            
            this.updateAveirFlag(manualProductId);
            this.filterDrDeviceList();
        }
    }

    implantOnChange($event, isDr: boolean = false) {
        // let impId = $event.option.value
        const selectedValue = $event.value ?? $event.option?.value;
        const acctId = typeof selectedValue === 'object' ? selectedValue?.acctId : selectedValue;
        const match =
            this.cliniciansList?.find((x: any) => String(x?.acctId) === String(acctId)) ||
            this.implantIds?.find((x: any) => String(x?.acctId) === String(acctId));
        if (isDr) {
            this.deviceForm.get('drImplantPhyId').setValue(acctId);
            this.deviceForm.get('drImplantPhyIdName').setValue(match || null);
            this.implantPhySearchControlDR.setValue('', { emitEvent: false });
        } else {
            this.deviceForm.get('implantPhyId').setValue(acctId);
            this.deviceForm.get('implantPhyIdName').setValue(match || null);
            this.implantPhySearchControl.setValue('', { emitEvent: false });
        }
    }

    deviceOnChange($event) {
        this.transmitterVisibleOnEmpty = false;
        let rawFormData = this.patientDeviceForm.getRawValue();
        let productId = $event.value;
        const deviceObj = this.deviceList?.find(d => d.value == productId);
        this.transmissionDetailService.updateDevice(
            {
                isDeviceChange: true,
                devName: deviceObj?.label,
                patFirstName: rawFormData?.patientDetails?.firstName,
                patLastName: rawFormData?.patientDetails?.lastName,
                patientNum: rawFormData?.patientDetails?.patientNum
            });
        const matchedDevice = this.dropDownsList.devices?.find(d => d.value == productId);
        this.deviceForm.get('modelNum').setValue(matchedDevice?.deviceModelNum ?? '');
        if (deviceObj) {
            this.deviceForm.get('productName').setValue(deviceObj, { emitEvent: false });
        }
        this.deviceSearchControl.setValue('', { emitEvent: false });
        this.updateAveirFlag(productId);
        
        this.togglePhysicianOpt.emit(productId?.toString());
    
        const currentPhysicianId = this.deviceForm.get('implantPhyId').value;
        if (currentPhysicianId && currentPhysicianId !== '') {
            this.deviceForm.get('implantPhyIdName').setErrors(null);
            this.deviceForm.get('implantPhyIdName').markAsTouched();
        }
        
        // Reset DR device selection when primary device changes to maintain valid pairing
        const currentDrProductId = this.deviceForm.get('drProductId')?.value;
        if (currentDrProductId) {
            const primaryCode = String(productId || '').trim();
            const drCode = String(currentDrProductId || '').trim();
            const primaryIsVr = this.aveirVrCodes.has(primaryCode);
            const primaryIsAr = this.aveirArCodes.has(primaryCode);
            const drIsVr = this.aveirVrCodes.has(drCode);
            const drIsAr = this.aveirArCodes.has(drCode);
            
            // Clear DR device if both are same type (both VR or both AR)
            if ((primaryIsVr && drIsVr) || (primaryIsAr && drIsAr)) {
                this.deviceForm.get('drProductId').setValue('', { emitEvent: false });
                this.deviceForm.get('drProductName').setValue('', { emitEvent: false });
            }
        }
        
        this.filterDrDeviceList();
            // const tz = this.dateLabel?.toUpperCase();
            // dayjs.extend(customParseFormat);
            // const imp_date = dayjs(Date()).format(tz) as any;
            let imp_date = this. helperService.parseGMTDateTime(
                new Date(),
                false,
                false,
                this.userProfileObject?.clinicUserTZ,
                this.userProfileObject?.dateFormat,
                this.userProfileObject?.timeFormat,
                this.userProfileObject?.locale
                );
            if(this.functionMode==='enroll'){
            this.deviceForm
                    .get('implantDate')
                    .patchValue(imp_date);
            }
        if (this.clinicDetailsInfo?.avrProdIds?.split(',').includes(productId?.toString())) {
            this.transmitterVisibleOnEmpty = false;
        } else if(this.clinicDetailsInfo?.icmProdIds?.split(',').includes(productId?.toString())) {
                this.transmitterVisibleOnEmpty = false;
            }
            else if(this.clinicDetailsInfo?.ngqProdIds?.split(',').includes(productId?.toString())) {
                this.transmitterVisibleOnEmpty = false;
            } else {
                this.transmitterVisibleOnEmpty = true;
            }

        // if (this.checkinTrueAAIProd(productId)) {
        //     this.showTrueAAIInfoFlag = true;
        // } else {
        //     this.showTrueAAIInfoFlag = false;
        // }
        this.getTrueAAIProd(productId);
        this.deviceForm.get('leadChmbSettingCd')?.setValue(null, { emitEvent: false });
        // attempt update after primary change
        this.getArVrPairLabel();
        this.filterDevices(deviceObj);
    }

    // DR device selection handler (does not overwrite primary productId)
    drDeviceOnChange($event) {
        const drProductId = $event.value;
        const drProductObj = this.deviceList?.find(d => d.value == drProductId);
        this.deviceForm.get('drProductId').setValue(drProductId);
        const matchedDrDevice = this.dropDownsList.devices?.find(d => d.value == drProductId);
        this.deviceForm.get('drModelNum')?.setValue(matchedDrDevice?.deviceModelNum ?? '');
        if (drProductObj) {
            this.deviceForm.get('drProductName').setValue(drProductObj, { emitEvent: false });
        }
        this.drDeviceSearchControl.setValue('', { emitEvent: false });
        this.toasterService.clear();
        this.deviceForm.get('drProductName').setErrors(null);
        
        // attempt update after DR change
        let imp_date = this. helperService.parseGMTDateTime(
                new Date(),
                false,
                false,
                this.userProfileObject?.clinicUserTZ,
                this.userProfileObject?.dateFormat,
                this.userProfileObject?.timeFormat,
                this.userProfileObject?.locale
                );
            if(this.functionMode==='enroll'){
            this.deviceForm
                    .get('drImplantDate')
                    .patchValue(imp_date);
            }
        this.getArVrPairLabel();
    }

    validateDrDevice(event: Event) {
        this.toasterService.clear();
        const manualDrDeviceInput = (event.target as HTMLInputElement).value?.trim();
        
        if (!manualDrDeviceInput) {
            this.deviceForm.get('drProductName').setErrors(null);
            return;
        }

        const primaryCode = String(this.deviceForm.get('productId')?.value || '').trim();
        if (!primaryCode) {
            return;
        }

        const primaryIsVr = this.aveirVrCodes.has(primaryCode);
        const primaryIsAr = this.aveirArCodes.has(primaryCode);
        
        if (!(primaryIsVr || primaryIsAr)) {
            return;
        }

        const targetSet = primaryIsVr ? this.aveirArCodes : this.aveirVrCodes;
        const availableDrDevices = this.deviceList?.filter(d => targetSet.has(String(d.value)));

        const matchedDevice = availableDrDevices?.find(option => 
            option.label?.toUpperCase() === manualDrDeviceInput.toUpperCase()
        );

        if (!matchedDevice) {
            this.deviceForm.get('drProductName').setErrors({ 'invalidOption': true });
        } else {
            this.deviceForm.get('drProductName').setErrors(null);
            this.deviceForm.get('drProductId').setValue(matchedDevice.value);
            this.deviceForm.get('drProductName').setValue(matchedDevice);
            this.getArVrPairLabel();
        }
    }

    drDeviceNameBlur(event: Event) {
        this.toasterService.clear();
        const manualDrDeviceInput = (event.target as HTMLInputElement).value?.trim();
        
        if (!manualDrDeviceInput) {
            this.deviceForm.get('drProductName').setErrors(null);
            this.deviceForm.get('drProductId').setValue('');
            return;
        }

        const primaryCode = String(this.deviceForm.get('productId')?.value || '').trim();
        if (!primaryCode) {
            return;
        }

        const primaryIsVr = this.aveirVrCodes.has(primaryCode);
        const primaryIsAr = this.aveirArCodes.has(primaryCode);
        
        if (!(primaryIsVr || primaryIsAr)) {
            return;
        }

        const targetSet = primaryIsVr ? this.aveirArCodes : this.aveirVrCodes;
        const availableDrDevices = this.deviceList?.filter(d => targetSet.has(String(d.value)));

        const matchedDevice = availableDrDevices?.find(option => 
            option.label?.toUpperCase() === manualDrDeviceInput.toUpperCase()
        );

        if (!matchedDevice) {
            this.deviceForm.get('drProductName').setErrors({ 'invalidOption': true });
        } else {
            this.deviceForm.get('drProductName').setErrors(null);
            this.deviceForm.get('drProductId').setValue(matchedDevice.value);
            this.deviceForm.get('drProductName').setValue(matchedDevice);
            this.getArVrPairLabel();
        }
    }

    getArVrSelectionLabel(): string {
        // Translation key expected to be provided externally; fallback string if missing
        return this.labels['label.gb.select_ar_vr_device'];
    }

    /**
     * Returns the combined Aveir DR LP label when BOTH an AR and a VR device
     * have been selected (in any order across the primary and DR device fields).
     * Format: "Aveir™DR LP [Device Model] / [DR Device Model]" (preserving order).
     * If pairing not complete, returns null so caller can fallback to guidance text.
     */
    getArVrPairLabel() {
        const primaryCode = String(this.deviceForm?.get('productId')?.value || '').trim();
        const drCode = String(this.deviceForm?.get('drProductId')?.value || '').trim();
        const hasAr = this.aveirArCodes.has(primaryCode) || this.aveirArCodes.has(drCode);
        const hasVr = this.aveirVrCodes.has(primaryCode) || this.aveirVrCodes.has(drCode);

        const model1 = this.extractModelNumberFromProductId(primaryCode);
        const model2 = this.extractModelNumberFromProductId(drCode);
        if (!this.deviceForm)  this.aveirPairLabel = this.labels?.['label.gb.selectDR'];
        
        else if (!primaryCode || !drCode)  this.aveirPairLabel = this.labels?.['label.gb.selectDR']; // need both selected

        else if (!hasAr || !hasVr)  this.aveirPairLabel = this.labels?.['label.gb.selectDR']; // need both selected

        else if (!model1 || !model2)  this.aveirPairLabel = this.labels?.['label.gb.selectDR'];
        else{ 
            this.fetchAveirPairLabel(model1, model2).subscribe(label => {
                 this.aveirPairLabel =  `${this.labels?.['label.gb.DR']} ${model1} / ${model2}`;
            });
        }   
    }

    /**
     * Helper to derive model numbers from current device selections.
     */
    private extractModelNumbers(): { model1: string | null; model2: string | null } {
        if (!this.deviceForm) return { model1: null, model2: null };
        const primaryCode = String(this.deviceForm.get('productId')?.value || '').trim();
        const drCode = String(this.deviceForm.get('drProductId')?.value || '').trim();
        
        const model1 = this.extractModelNumberFromProductId(primaryCode);
        const model2 = this.extractModelNumberFromProductId(drCode);
        
        return { model1, model2 };
    }

    /**
     * Extract model number from product ID by finding it in the dropDownsList.
     */
    private extractModelNumberFromProductId(productId: string): string | null {
        if (!productId || !this.dropDownsList?.devices) return null;
        
        const device = this.dropDownsList.devices.find(d => String(d.value) === productId);
        if (!device || !device.label) return null;
        
        // Extract the last part after the last space (e.g., "Aveir™ VR LSP202V" -> "LSP202V")
        const parts = device.label.trim().split(' ');
        return parts.length > 0 ? parts[parts.length - 1] : null;
    }

    /**
     * Stub for future API integration.
     * Replace implementation to call backend endpoint returning formatted pair label.
     * Expected eventual format: "Aveir™DR LP MODEL1 / MODEL2" possibly localized.
     */
    private fetchAveirPairLabel(model1: string, model2: string): Observable<string> {
        // TODO: Replace with actual service call, e.g. this.deviceApi.getAveirPairLabel(model1, model2)
        // Keeping synchronous Observable for now.
        const composed = `Aveir™DR LP ${model1} / ${model2}`;
        return of(composed);
    }

    getTrueAAIProd(sel) {
        // let filteredData = this.trueInfo.filter(function (str) {
        //     return str.indexOf(sel) > -1;
        // });

        this.showTrueAAIInfoFlag =  this.clinicDetailsInfo.trueAAIProdIds?.split(',').includes(sel);
       // this.showTrueAAIInfoFlag = filteredData.length > 0;
    }

    onKey(e) {
        let tempArr = [];
        this.deviceList.forEach((item) => {
            if (item.toLowerCase().includes(e)) {
                tempArr.push(item);
            }
        });
        this.deviceList = tempArr;
    }

    deviceNameCompare(o1, o2) {
        return o1 === o2;
    }
    compareDeviceCd(o1, o2) {
        return o1 == o2;
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }
    disableTransmitterBox() {
        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return false;
        } else {
            return true;
        }
    }
    disableTransmitterRadioBtn() {
        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'view'
        ) {
            return true;
        } else {
            return true;
        }
    }
    getDeviceName() {
        const patientDevice = this.getPrimaryPatientDevice(this.patRes);
        if (!patientDevice) return '';
        
        let patDevice = this.patRes.dropdowns
            ? this.patRes.dropdowns.devices.filter((dev) => {
                return dev.value == patientDevice.productId;
            })
            : [];
        this.transmitterVisibleOnEmpty = (this.isICMCategory || this.isNGQCategory || this.isLPCategory) ? false : true;
        return patDevice.length !== 0 ? patDevice[0]?.label : patientDevice?.deviceFullDescription;
    }
    formatPhysician(patPhys: any): string {
        if (patPhys?.length == 0 || patPhys === null || patPhys === undefined) return '';
        const name = [
            patPhys?.lastName ? `${patPhys.lastName},` : '',
            patPhys?.firstName ?? '',
            patPhys?.middleName ?? '',
            patPhys?.credentialsCd ?? ''
        ]
            .map(s => String(s).trim())
            .filter(s => s.length > 0)
            .join(' ');
        return patPhys?.mainLocation ? `${patPhys.mainLocation}: ${name}` : name;
    }
    getImplantPhysicianDisplay(acctId: any): string {
        if (!acctId) return '';
        const match =
            this.implantIds?.find(p => String(p?.acctId) === String(acctId)) ||
            this.cliniciansList?.find(p => String(p?.acctId) === String(acctId));
        return match ? this.formatPhysician(match) : '';
    }
    getImplantPhysicianTriggerText(isDR: boolean): string {
        let implantPhyID = isDR ? this.deviceForm?.get('drImplantPhyId')?.value 
        : this.deviceForm?.get('implantPhyId')?.value;
        const selectedObj = isDR ? this.deviceForm?.get('drImplantPhyIdName')?.value 
        : this.deviceForm?.get('implantPhyIdName')?.value;
        if (selectedObj && selectedObj.acctId) {
            return this.formatPhysician(selectedObj);
        }
        return this.getImplantPhysicianDisplay(implantPhyID);
    }
    getImpData(patPhys: any) {
        return this.formatPhysician(patPhys)?.toLowerCase();
    }
    getChamb() {
        const patientDevice = this.getPrimaryPatientDevice(this.patRes);
        if (!patientDevice) return '';
        
        let patChamb = this.patRes?.dropdowns.leadChmbCodes.filter((code) => {
            return code.codeId == patientDevice.leadChmbSettingCd;
        });
        if (patChamb.length == 0) {
            return '';
        }else{
            return patChamb[0].description;
        }
    }
    getSerialNum() {
        const patientDevice = this.getPrimaryPatientDevice(this.patRes);
        if (!patientDevice) return '';
        
        let patSerNum = patientDevice?.serialNum;
        while (patSerNum && patSerNum.toString().indexOf('0') === 0) patSerNum = patSerNum.replace('0', '')
        return patSerNum;
    }

    getImpDate() {
        const patientDevice = this.getPrimaryPatientDevice(this.patRes);
        if (!patientDevice) return '';
        
        let impDate = patientDevice?.implantDate?.toString();
        return impDate ? impDate : '';
    }

    openViewLeadsDialog() {
        const dialogRef = this.dialog.open(ViewleadsDialogComponent, {
            width: '50%',
            data: this.patRes,
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }

    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.localizationService.generateLocalizedStr(
                item.message
            );
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                this.toasterService.success(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                });
            }
        });
    }
    
    /**
     * Handle click on remove button for primary device
     * Mark primary device as removed and make all fields read-only
     */
    onRemovePrimaryDevice() {
        this.primaryDeviceRemoved = true;
        this.drDeviceRemoved = false;
        this.deviceForm.get('deviceRemovalState')?.setValue('primary', { emitEvent: false });
        
        const primaryFields = ['serialNum', 'productId', 'productName', 'implantDate', 'implantPhyId', 'implantPhyIdName'];
        primaryFields.forEach(ctrl => {
            const c = this.deviceForm.get(ctrl);
            if (c) {
                c.disable({emitEvent: false});
            }
        });
        
        this.dataChange.emit(true);
    }
    
    /**
     * Handle click on remove button for DR device
     * Mark DR device as removed and make all DR fields read-only
     */
    onRemoveDrDevice() {
        this.drDeviceRemoved = true;
        this.primaryDeviceRemoved = false;
        this.deviceForm.get('deviceRemovalState')?.setValue('dr', { emitEvent: false });
        
        const drFields = [
            'drSerialNum','drProductId','drProductName','drImplantDate','drImplantPhyId','drImplantPhyIdName'
        ];
        drFields.forEach(ctrl => {
            const c = this.deviceForm.get(ctrl);
            if (c) {
                c.disable({emitEvent: false});
            }
        });
        
        this.dataChange.emit(true);
    }
    
    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }

    handleEmptyInput($event: any) {
        if($event.target.value === '') { // checks if user erased dropdown text
            this.transmitterVisibleOnEmpty = true;
            // In edit mode, keep DR section visible when the primary device name
            // is cleared — DR should only hide when a non-Aveir device is selected.
            if (this.displayMode !== 'edit') {
                this.clearDrDeviceFields();
                this.showDrDeviceCheckbox = false;
            }
          }
          else{
            this.transmitterVisibleOnEmpty = false;
            // if(this.isNGQCategory){
            //     this.deviceForm.get('transmitter').setValue(true)
            // }
          }
    }

    public dateValidator(event) {
            const value = this.patientDeviceForm?.get('deviceData')?.get('implantDate')?.value;
            if(!value) return;
            const isValid = this.helperService.dateValidator(value,this.userProfile?.dateFormat);
            isValid ? null : this.patientDeviceForm?.get('deviceData')?.get('implantDate')?.setErrors({incorrect : true});
    }

    serialNumBlur(e) {
        let srCtrl =  this.deviceForm.get('serialNum');
        if(srCtrl.value == null){
            srCtrl.setValue('')
            return
        }
        srCtrl.setValue(String(srCtrl.value).trim())
    }
}
